var render = function render(){var _vm=this,_c=_vm._self._c;return _c((_vm.isRedirect) ? 'a' : 'router-link',{tag:"component",attrs:{"href":_vm.href,"to":_vm.toFinal}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }